export default __webpack_public_path__ + "static/media/times-solid.94749eb3.svg";